import RedirectKeepingSearch from '../utils/RedirectKeepingSearch';
import {placeRoutes} from './places/routes';
import {default as SettingsContainer} from './settings';
import {settingsRoutes} from './settings/routes';
import {stationRoutes} from './stations/routes';

export const dashboardRoutes = [
  {
    // My weather (FE #381), everyone's with no flag.
    path: '',
    lazy: () => import('../../screens/myWeather/MyWeatherHome'),
  },
  {
    path: 'stations',
    children: stationRoutes,
  },
  {
    // A place's page (FE #381 W4), everyone's with no flag: its frame, and
    // its Dashboard, Forecast tab, sun and moon pages under it (FE #331).
    path: 'places/:placeId',
    lazy: () => import('../../screens/myWeather/PlacePage/PlaceLayout'),
    children: placeRoutes,
  },
  {
    path: 'settings',
    children: settingsRoutes,
    Component: SettingsContainer,
  },
  {
    // Moved to the top-level /forecast-maps (full-width, no nav rail). Keep
    // these redirects so old /app/forecast-maps deep links still resolve.
    path: 'forecast-maps',
    element: <RedirectKeepingSearch to="/forecast-maps" />,
  },
  {
    path: 'forecast-maps/builder',
    element: <RedirectKeepingSearch to="/forecast-maps/builder" />,
  },
  {
    path: 'admin/debug',
    lazy: () => import('../../screens/admin/DebugScreen'),
  },
  {
    path: 'admin/debug/dependencies',
    lazy: () => import('../../screens/admin/DependenciesScreen'),
  },
  {
    path: '*',
    lazy: async () => import('../../screens/NotFound'),
  },
];
